export default {
    albums: [
        {
            id: 'brave',
            name: 'BRAVE',
            spec: {
                '통상반': true,
                '초회한정반 Blu-ray': true,
            },
            release: '20190911',
        },
        {
            id: 'best2019',
            name: 'ARASHI 5×20 All the BEST!! 1999-2019',
            spec: {
                '통상반': true,
                '초회한정반1': true,
                '초회한정반2': true,
            },
            release: '20190626',
        },
        {
            id: 'untitled',
            name: '「untitled」',
            spec: {
                '통상반': true,
                '초회한정반': true,
            },
            release: '20171018',
        },
        {
            id: 'kimiuta',
            name: '君のうた',
            spec: {
                '통상반': true,
                '초회한정반': true,
            },
            release: '20181024',
            comments: '｢僕とシッポと神楽坂｣ 주제가',
        },
        {
            id: 'natsu',
            name: '夏疾風',
            spec: {
                '통상반': true,
                '초회한정반': true,
                '고교야구반(초회한정)': true,
            },
            release: '20180725',
            comments: '2018 코시엔 테마송',
        },
        {
            id: 'fta',
            name: 'Find The Answer',
            spec: {
                '통상반': true,
                '초회한정반': true,
            },
            release: '20180221',
            comments: '「99.9-刑事専門弁護士-　SEASONⅡ」 주제가',
        },
        {
            id: 'doors',
            name: 'Doors～勇気の軌跡～',
            spec: {
                '통상반': true,
                '초회한정반1': true,
                '초회한정반2': true,
            },
            release: '20171108',
            comments: '「先に生まれただけの僕」 주제가',
        },
        {
            id: 'tunagu',
            name: 'つなぐ',
            spec: {
                '통상반': true,
                '초회한정반': true,
            },
            release: '20170628',
            comments: '「忍びの国」 주제가',
        },
    ],
    concerts: [
        {
            id: 'liveuntitled',
            name: 'ARASHI LIVE TOUR 2017-2018 「untitled」',
            spec: {
                '통상반 Blu-lay': true,
                '초회한정반 Blu-lay': true,
            },
            release: '20180613',
        },
        {
            id: 'livehappy',
            name: 'ARASHI LIVE TOUR 2016-2017 Are You Happy?',
            spec: {
                '통상반 Blu-lay': true,
                '초회한정반 Blu-lay': true,
            },
            release: '20170531',
        },
        {
            id: 'livejapo',
            name: 'ARASHI LIVE TOUR 2015 Japonism',
            spec: {
                '통상반': true,
                '초회한정반': false,
            },
            release: '20160824',
        },
        {
            id: 'livedigi',
            name: 'ARASHI LIVE TOUR 2014 THE DIGITALIAN',
            spec: {
                '통상반': true,
                '초회한정반': false,
            },
            release: '20150729',
        },
        {
            id: 'livehawaii',
            name: "ARASHI BLAST in Hawaii",
            spec: {
                '통상반 Blu-ray': true,
                '초회한정반': false,
            },
            release: '20150415',
        },
        {
            id: 'livefes13',
            name: "ARASHI　アラフェス'13 NATIONAL STADIUM 2013",
            spec: {
                '통상반 Blu-ray': true,
                '통상반/초회프레스사양': false,
            },
            release: '20140521',
        },
        {
            id: 'liveaaa06',
            name: "ARASHI AROUND ASIA Thailand-Taiwan-Korea",
            spec: {
                '통상반': true,
                '초회한정반': false,
            },
            release: '20070523',
        },
        {
            id: 'liveizat',
            name: "2004　嵐！いざッ、Now Tour!!",
            spec: {
                '통상반': true,
            },
            release: '20050101',
        },
        {
            id: 'livehows',
            name: "How's it going? SUMMER CONCERT 2003",
            spec: {
                '통상반': true,
            },
            release: '20031217',
        },
    ],
    magazines: [
        {
            name: 'J Movie Magazine Vol.24',
            release: '201706'
        },
        {
            name: '피아 Move Special 2017 summer',
            release: '201706'
        },
        {
            name: '시네마스퀘어 vol.93',
            release: '201706'
        },
        {
            name: 'ESSE 2017년 7월호',
            release: '201706'
        },
        {
            name: '다.빈치 2017년 7월호',
            release: '201706'
        },
        {
            name: '도쿄워커 2017년 7월호',
            release: '201706'
        },
        {
            name: '후쿠오카워커 2017년 7월호',
            release: '201706'
        },
        {
            name: '요코하마워커 2017년 7월호',
            release: '201706'
        },
        {
            name: '도카이워커 2017년 7월호',
            release: '201706'
        },
        {
            name: '칸사이워커 2017년 07/04호',
            release: '201706'
        },
        {
            name: 'FLIX 2017년 8월호',
            release: '201706'
        },
        {
            name: '+act. 2017년 7월호',
            release: '201706'
        },
        {
            name: 'BARFOUT! 262',
            release: '201706'
        },
        {
            name: '키네마준보NEXT vol.13',
            release: '201706'
        },
        {
            name: '야성시대 164호 2017년 7월호',
            release: '201706'
        },
        {
            name: 'Cut 2017년 7월호',
            release: '201706'
        },
        {
            name: 'PICT-UP 2017년 8월호',
            release: '201706'
        },
        {
            name: '예술신조 2017년 7월호',
            release: '201706'
        },
        {
            name: 'with 2017년 8월호',
            release: '201706'
        },
        {
            name: '주간아사히 2017년 6/30호',
            release: '201706'
        },
        {
            name: 'AERA STYLE MAGAZINE Vol.35 2017년 6/24호',
            release: '201706'
        },
        {
            name: 'TV가이드 Alpha EPISODE F',
            release: '201706'
        },
        {
            name: '닛케이엔터테인먼트! 2017년 8월호',
            release: '201707'
        },
        {
            name: 'MORE 2017년 8월호',
            release: '201707'
        },
        {
            name: "Men's NONNO 2017년 8월호",
            release: '201707'
        },
        {
            name: 'anan 2017/07/05',
            release: '201707'
        },
        {
            name: 'non·no 2017년 12월호',
            release: '201710'
        },
        {
            name: 'non·no 2018년 2월호',
            release: '201712'
        },
        {
            name: 'anan 2018/01/10',
            release: '201711'
        },
        {
            name: 'with 2018년 2월호',
            release: '201712'
        },
        {
            name: '월간쟈테레 2019년 2월호',
            release: '201812'
        },
        {
            name: "Men's NONNO 2018년 6월호",
            release: '201805'
        },
        {
            name: 'J Movie Magazine Vol.34',
            release: '201804'
        },
        {
            name: '키네마준보NEXT Vol.19',
            release: '201804'
        },
        {
            name: '여성세븐 1월 25일호',
            release: '201801'
        },
    ],
    videos: [
        {
            name: '「忍びの国」豪華メモリアルBOX',
            release: '20180202',
        }
    ],
    photoBooks: [
        {
            name: 'ARASHI 5人の組曲 한정판',
            release: '20180626'
        },
        {
            name: 'Zoom in 大野智',
            release: '20171202'
        },
        {
            name: 'ARASHI COME ON ARENA!!',
            release: '20160617'
        },
    ],
    goods: [
        {
            name: '영화 라플라스의 마녀 팜플렛북',
            type: 'Book',
        }
    ],
    etc: [
        {
            name: '忍びの国〈上〉謀略の書',
            type: 'Comics',
            release: '20170623'
        },
        {
            name: '忍びの国〈下〉決戦の書',
            type: 'Comics',
            release: '20170721'
        }
    ],
}